module.exports = __webpack_public_path__ + "static/media/configurator-screen.39fb3072.png";